import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { array, object, number } from 'prop-types';
import useWindowWidth from '../custom-hooks/useWindowWidth';
import DynamicProperty from './DynamicProperty'
import FilteringDesktop from './FilteringDesktop';
import FilteringMobile from './FilteringMobile';
import useEffectNotOnLoad from '../custom-hooks/useEffectNotOnLoad'
import { autocomplete } from '../autocomplete';
import { AppContext } from '../AppContext';
import { setAttrTabs } from "../../utils/index";
import { getLocations } from "../../api";

const HotelOffers =({ allPlaces, theme }) =>{
  const [filtered, setFiltered] = useState(allPlaces);
  const [hideDropdown, setHideDropdown] = useState(true);
  const [inputValue, setInputValue] = useState('');
  const [isAllShown, setIsAllShown] = useState(false);
  const [currentCount, setCurrentCount] = useState(1);
  const [propertyListCollection, setPropertyListCollection] = useState([]);
  const [afterFilter, setAfterFilter] = useState([]);
  const [paginationLimit] = useState(10);
  const [paginationCount, setPaginationCount] = useState(0);
  const [finalLimit, setFinalLimit] = useState(10);//set initial equal to pagination limit
  const [shouldLoadLessEnable, setShouldLoadLessEnable] = useState(true);
  const [shouldLoadMoreEnable, setShouldLoadMoreEnable] = useState(true);

  const windowWidth = useWindowWidth();
  let closeButtonRef = null;
  const wrapperStyle = {
    width: '100%',
  };

  function scrollTop() {
    document.getElementById('find-a-hotel-tabs').scrollIntoView({
      block: 'end',
      inline: 'nearest'
    });
  }

  const CountProperty = ({ count }) => (
    <span className="property-search-count">
      {Number(count) < 0 ? 0 : count}
    </span>
  )
 
  function filterList(list, key, compareKey) {
    let filteredList;
    let isFiltered = false;
    compareKey = compareKey || "";
    //ignore casing 
    function compareString(value, key) {
      let regex = new RegExp('^' + value + '$', 'i');
      if (regex.test(key)) {
        return true;
      }
      return false;
    }

    function listFilter(list, key, lookFor) {
      filteredList = list.filter((hotel) => {
        if(compareString(hotel[lookFor], key)) {
          return true;
        }
      })
    }

    function completeListFilter(list, key, completeLook) {
      //tarverse completeLook and check , 1-3, 2-3
      let caseMatcher = '';
      let keySplit = key.split(',').map((item) => {
          return (item) ? item.trim() : "";
      });

      if(keySplit && keySplit.length > 3) {
        keySplit = keySplit.filter(entry => entry.trim() != '');
      }

      function cityStateFilter(list, keySplit) {
        filteredList = list.filter((hotel) => {
          if(compareString(hotel.state_name, keySplit[1]) &&
          compareString(hotel.city, keySplit[0])) {
            return true;
          }
        })
      }

      function cityCountryFilter(list, keySplit) {
        filteredList = list.filter((hotel) => {
          if(compareString(hotel.country_name, keySplit[2]) &&
          compareString(hotel.city, keySplit[0])) {
            return true;
          }
        })
      }

      function stateCountryFilter() {
        filteredList = list.filter((hotel) => {
          if(compareString(hotel.country_name, keySplit[2]) &&
          compareString(hotel.state_name, keySplit[1])) {
            return true;
          }
        })
      }

      function allFilter(list, keySplit) {
        filteredList = list.filter((hotel) => {
          if(compareString(hotel.country_name, keySplit[2]) &&
          compareString(hotel.state_name, keySplit[1]) &&
          compareString(hotel.city, keySplit[0])) {
            return true;
          }
        })
      }

      keySplit.forEach((element, index) => {
         if(element) {
           if(index === 0) {
            caseMatcher+= '0';
            return;
           }
           if(index === 1) {
            caseMatcher+= '1';
            return;
           }
           if(index === 2) {
            caseMatcher+= '2';
            return;
           }
         }
      });

      switch (caseMatcher) {
        case '01':
          cityStateFilter(list, keySplit)
          isFiltered = true;
          break;
        case '02':
          cityCountryFilter(list, keySplit)
          isFiltered = true;
          break;
        case '12':
          stateCountryFilter(list, keySplit)
          isFiltered = true;
          break;
        case '012':
          allFilter(list, keySplit)
          isFiltered = true;
          break;
        default:
          console.log('completeListFilter default case triggered for' + caseMatcher);
          break;
      }
      console.log(completeLook);
    }

    let lookFor = compareKey.split('-');
    if(lookFor && lookFor.length === 1 ) {
      //Search only city/state/country
      switch (String(lookFor)) {
        case 'city':
          listFilter(list, key, lookFor);
          isFiltered = true;
          break;
        case 'state_name':
          listFilter(list, key, lookFor);
          isFiltered = true;
          break;
        case 'country_name':
          listFilter(list, key, lookFor);
          isFiltered = true;
          break;
        default:
          console.log('compare key case not handled.. for' +lookFor);
          break;
      }
    }else {
      completeListFilter(list, key, lookFor);
    }
    if(isFiltered) {
      return filteredList;
    }
  }

  function loadLess() {
    const decCount = currentCount - 1;
    setCurrentCount(decCount);
  }

  function loadMore() {
    const incCount = currentCount + 1;
    setCurrentCount(incCount);
  }

  function inputChange(e) {
    const inputLength = e.target.value.length;
    const selection = autocomplete({
      element: e.target,
      allPlaces
    });
    (inputLength > 0) ? closeButtonRef.classList.remove('hidden')
    : closeButtonRef.classList.add('hidden');
    setInputValue(e.target.value);
    if (inputLength === 0) {
      setFiltered(allPlaces);
      setAfterFilter(propertyListCollection);
      setCurrentCount(1);
    } else if (inputLength < 3) {
      setHideDropdown(true);
    } else if (inputLength >= 3 && selection.length > 0) {
      setFiltered(selection);
      setCurrentCount(1);
      setIsAllShown(false);
      setHideDropdown(false);
    }
  }

  function seeAllHotels() {
    setFiltered(allPlaces);
    setIsAllShown(true);
    scrollTop();
    setInputValue('');
  }
  function clearInput(){
    closeButtonRef.classList.add('hidden');
    setInputValue('');
    setFiltered(allPlaces);
    setCurrentCount(1);
    setAfterFilter(propertyListCollection);
  }

  function onClick(e) {
    let elValue;
    let compareKey;
    if (e.target.classList.contains('suggestion')) {
      (e.target.getAttribute('data-value')) ? elValue = e.target.getAttribute('data-value')
      :  elValue = e.target.querySelector('span').textContent;
      compareKey = e.target.getAttribute('data-filter-key');
    } else {
      (e.target.parentNode.getAttribute('data-value')) ? elValue = e.target.parentNode.getAttribute('data-value')
        : elValue = e.target.parentNode.querySelector('span').textContent
      compareKey = e.target.parentNode.getAttribute('data-filter-key');
    }
    if (elValue === inputValue) {
      return;
    }
    scrollTop();
    setFiltered(allPlaces);
    setInputValue(elValue.replace(/,\s?,/g, ','));
    setCurrentCount(1);
    setAfterFilter(filterList(propertyListCollection, elValue, compareKey));
  }

 useEffect(() => {
  getLocations()
  .then(response => {
    if(response.widget && response.widget.length > 0) {
      setPropertyListCollection(response.widget);
    } else {
      console.error("Ajax is successful, No data sets from the server");
    }
  })
  .catch(e => {
      console.error(e);
  })
 }, []);

 useEffectNotOnLoad(() => {
  if(currentCount === 1) {
    setShouldLoadLessEnable(true);
    setShouldLoadMoreEnable(false)
  }
  const filteredCount =  afterFilter.length
  const pagCount = Math.ceil(filteredCount/paginationLimit);
  (pagCount <= 1 ) ? setShouldLoadMoreEnable(true): setShouldLoadMoreEnable(false);
  setPaginationCount(pagCount);
  ReactDOM.render(<CountProperty count= {filteredCount} />, document.getElementById('result-count'));
  ReactDOM.render(<DynamicProperty endLimit={finalLimit} loadLess={loadLess} loadMore={loadMore} list={afterFilter}  isLoadLess={shouldLoadLessEnable} isLoadMore={shouldLoadMoreEnable} pagination={paginationCount}/>,
     document.getElementById('property-filter-wrapper'));
}, [afterFilter]);

useEffectNotOnLoad(() => {
  ReactDOM.render(<DynamicProperty endLimit={finalLimit} loadLess={loadLess} loadMore={loadMore} list={afterFilter}  isLoadLess={shouldLoadLessEnable} isLoadMore={shouldLoadMoreEnable} pagination={paginationCount}/>,
     document.getElementById('property-filter-wrapper'));
}, [finalLimit, paginationCount]);

useEffectNotOnLoad(() => {
  const final = currentCount * paginationLimit;
  (currentCount > 1) ? setShouldLoadLessEnable(false) : setShouldLoadLessEnable(true);
  (currentCount !== paginationCount )? setShouldLoadMoreEnable(false): setShouldLoadMoreEnable(true);
  setFinalLimit(final);
}, [currentCount]);

  return (
    <AppContext.Provider value={{ onClick, theme}}>
      <div className="tabs-panel tabs-search is-active filter-offer-main" id="panel-hotels">
        <div className="grid-x align-center autocomplete-wrap" style={wrapperStyle}>
          <div className="cell small-9 large-8 find-a-hotel-autocomplete filter-offers-autocomplete">
            <div className="find-a-hotel-auto-container">
              <input
                onChange={inputChange}
                onFocus={setAttrTabs}
                onBlur={setAttrTabs}
                // onKeyDown={onKeyDown} 
                value={inputValue}
                placeholder='Enter a City, State, or Region'
                autoComplete="off"
                type="text"
                id="find-a-hotel"
                className="find-a-hotel"
                name="find-a-hotel"
                aria-label="find-a-hotel"
              />
              <button
              ref ={input => { closeButtonRef = input }}
              onClick={clearInput}
              className="clear-filter hidden"
              >
             X
            </button>
            </div>
          
          </div>
          <div className="cell small-8 find-a-hotel-autocomplete filter-mobile-wrap">
            {!hideDropdown &&
              !isAllShown &&
              allPlaces.length !== filtered.length &&
              windowWidth <= 1024 && (
                <FilteringMobile
                  placeholder='Enter a City, State, or Region'
                  filtered={filtered}
                  seeAllHotels={seeAllHotels}
                  setHideDropdown={setHideDropdown}
                />
              )}
          </div>
        </div>
        {allPlaces.length !== filtered.length && windowWidth > 1024 ? (
          // else if filtering and on large screens
          <FilteringDesktop filtered={filtered} theme={theme} />
        ) : ''}
      </div>
    </AppContext.Provider>
  );
}

HotelOffers.propTypes = {
  allPlaces: array.isRequired,
  theme: object,
  count: number
};

export default HotelOffers;
